import { Link } from "react-router-dom";
import type { QuickAction } from "~/features/dashboard/types";

export function QuickActions() {
  const quickActions: QuickAction[] = [
    {
      title: "Start Auto Calls",
      description: "Launch the automated dialer for today's most urgent deliveries.",
      icon: "🚀",
      buttonLabel: "Go to Auto calls",
      variant: "secondary",
      href: "/autocall",
    },
    {
      title: "Transfer Queue",
      description: "View and manage the transfer queue for today's deliveries.",
      icon: "📤",
      buttonLabel: "Go to Transfer Queue",
      variant: "secondary",
      href: "/transfer-queue",
    },
    {
      title: "Review Scheduled Orders",
      description: "Review and manage the scheduled orders for today's and future deliveries.",
      icon: "📦",
      buttonLabel: "Go to Scheduled",
      variant: "secondary",
      href: "/scheduled",
    },
    {
      title: "NAV Posted Orders",
      description: "Review and manage the NAV posted orders for today's deliveries.",
      icon: "📤",
      buttonLabel: "Go to Posted Orders",
      variant: "secondary",
      href: "/posted-order",
    },
    {
      title: "Call Audits",
      description: "Review and manage the call audits for deliveries.",
      icon: "📞",
      buttonLabel: "Go to Call Audits",
      variant: "secondary",
      href: "/call-audit",
    },
  ];

  return (
    <section className="table-container" style={{ padding: 24, borderRadius: 16 }}>
      <h2 style={{ marginTop: 0, fontSize: 18 }}>Quick Actions</h2>
      <p style={{ marginTop: 4, color: "var(--text-muted)", fontSize: 13 }}>
        Jump directly to the workflow you need.
      </p>
      <div className="quick-actions-grid-wrapper">
        <div className="quick-actions-grid">
        {quickActions.map(action => (
          <div key={action.title} className="quick-actions-card">
            <div className="quick-actions-card-content">
              <div style={{ fontSize: 28 }}>{action.icon}</div>
              <div>
                <div style={{ fontWeight: 600 }}>{action.title}</div>
                <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 4 }}>
                  {action.description}
                </div>
              </div>
            </div>
            <Link
              to={action.href}
              className={`btn btn-${action.variant} quick-actions-card-btn`}
              style={{ width: "100%", justifyContent: "center", textDecoration: "none" }}
            >
              {action.buttonLabel}
            </Link>
          </div>
        ))}
        </div>
      </div>
      <style>{`
        .quick-actions-grid-wrapper {
          margin-top: 16px;
        }
        .quick-actions-grid {
          display: grid;
          gap: 16px;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          align-items: stretch;
        }
        @media (min-width: 1350px) {
          .quick-actions-grid {
            grid-template-columns: repeat(5, minmax(0, 1fr));
          }
        }
        .quick-actions-card {
          border: 1px solid var(--border);
          border-radius: 12px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          min-height: 170px;
        }
        .quick-actions-card-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .quick-actions-card-btn {
          margin-top: auto;
          flex-shrink: 0;
          white-space: nowrap;
        }
      `}</style>
    </section>
  );
}
